export const API_ENDPOINTS = {
    CHANGEPASSWORD: {
        CHANGE_PASSWORD: `/employee/update-password`,
    },
}